import { Badge, Tag } from 'antd';
import { FC, memo } from 'react';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteDnsRecordsQuery } from '@/modules/DnsRecords';

interface Props extends AppAutocompleteComponentProps {}

export const DnsRecordsAllAutocomplete: FC<Props> = memo((props) => {
  return (
    <AppAutocomplete<typeof useAutocompleteDnsRecordsQuery>
      {...props}
      optionItemRender={(opts) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          {opts?.name}
          {opts?.apiProvider ? <Badge count={opts.apiProvider} /> : <Tag style={{ borderRadius: 20 }}>без провайдера</Tag>}
        </div>
      )}
      options={(data) =>
        parseSelectData(data, {
          value: 'id',
          label: 'name',
        })
      }
      notFoundDescription="Немає DNS-записів"
      placeholder="Знайдіть DNS-запис"
      query={useAutocompleteDnsRecordsQuery}
    />
  );
});
